import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'

type ThingsToDoOpenedSourcePath =
  | 'trip_planner.drawer.place_detail'
  | 'trip_planner.list.stop_actions'
  | 'trip_planner.itinerary.canvas.experience_tile'

// Dispatch from the opening control, not on drawer mount: map return and Back remount it unasked.
export function buildThingsToDoOpenedActivityEntry(
  destinationName: string,
  sourcePath: ThingsToDoOpenedSourcePath,
): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'things_to_do_opened',
    label: 'Opened things to do',
    displayText: boundActivityDisplayText(`Opened things to do in "${destinationName}"`),
    sourcePath,
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
